import { InputAdornment, Typography, selectClasses } from "@mui/material";
import { inputBaseClasses } from "@mui/material/InputBase";
import { FC } from "react";
import { SelectField } from "src/shared/components";
import { defaultFilterOption } from "../../model/constants";
import { IFilterItem, IFilterValue } from "../../model/types";
import { FilterButton } from "./FilterButton";

interface ITableFilterSelectProps {
  filter: IFilterItem<string | string[]>;
  onChange: (v: IFilterValue<string[] | number[] | string | number>) => void;
  multiple?: boolean;
  customRenderValue?: (
    v: string[] | number[] | string | number,
  ) => string | number | undefined;
}

const TableFilterSelect: FC<ITableFilterSelectProps> = ({
  filter: { options, name, value, title, hideClearButton },
  onChange,
  multiple,
  customRenderValue,
}) => {
  if (!options) return <Typography>Нет опций</Typography>;

  const defaultOption = hideClearButton ? [] : defaultFilterOption;
  const extendedOptions = multiple ? options : [...defaultOption, ...options];
  let showClearButton = Boolean(value);
  let isFilterHasActiveAllOption = !value;

  if (multiple) {
    showClearButton = value.length > 0;
    isFilterHasActiveAllOption =
      !value.length || (value.length === 1 && value[0] === "");
  }

  if (hideClearButton) {
    showClearButton = false;
  }

  let renderValue = undefined;

  if (multiple && !customRenderValue) {
    renderValue = (v: string[] | number[] | string | number) => {
      if (!Array.isArray(v) || v.length === 0) {
        return defaultFilterOption[0]?.name ?? "";
      }

      if (v.length === 1) {
        const selected = options.find((option) => option.value === v[0]);

        return selected?.name ?? String(v[0]);
      }

      return String(v.length);
    };
  }

  return (
    <SelectField<string | number | string[] | number[]>
      multiple={multiple}
      value={value}
      name={name}
      defaultValue=""
      displayEmpty
      onChange={(e) => onChange({ name, value: e.target.value })}
      renderValue={customRenderValue ? customRenderValue : renderValue}
      slotProps={{
        input: {
          placeholder: title,
        },
      }}
      startAdornment={
        title ? (
          <InputAdornment position="start">
            <Typography
              sx={{
                whiteSpace: "nowrap",
                color: "grey.900",
                fontWeight: isFilterHasActiveAllOption ? "400" : "700",
              }}
            >
              {`${title}${!(multiple && value.length > 1) ? ":\xa0" : ""}`}
            </Typography>
          </InputAdornment>
        ) : undefined
      }
      endAdornment={
        showClearButton ? (
          <InputAdornment position="end" sx={{ mr: 4 }}>
            <FilterButton
              onClick={() => onChange({ name, value: multiple ? [] : "" })}
              iconName="close"
            />
          </InputAdornment>
        ) : undefined
      }
      options={extendedOptions}
      sx={(theme) => ({
        maxWidth: "300px",
        [`&.${inputBaseClasses.adornedStart}`]: {
          paddingLeft: theme.spacing(3),
        },
        [`& .${selectClasses.select}`]: {
          fontWeight: isFilterHasActiveAllOption ? "400" : "700",
          paddingLeft: "0!important",
          paddingRight: showClearButton
            ? `${theme.spacing(3.75)}!important`
            : `${theme.spacing(6.5)} !important`,
        },
      })}
    />
  );
};

export default TableFilterSelect;
